import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { checkAdminSession } from './adminAuth';
import { API_URL } from './newsConfig';

export default function ProtectedAdminRoute({ children }) {
  const location = useLocation();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let cancelled = false;

    const verify = async () => {
      try {
        const ok = await checkAdminSession(API_URL);
        if (!cancelled) {
          setStatus(ok ? 'authenticated' : 'unauthenticated');
        }
      } catch {
        if (!cancelled) {
          setStatus('unauthenticated');
        }
      }
    };

    verify();
    return () => {
      cancelled = true;
    };
  }, []);

  if (status === 'loading') {
    return (
      <div className="min-h-screen bg-cpre-pebble/20 flex items-center justify-center">
        <p className="text-cpre-new-yew font-medium">Verifying admin session…</p>
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
